import { HTMLAttributes } from 'react'

import Container from '@/components/base/container'
import Grid from '@/components/base/grid'
import Media from '@/components/base/media'
import Section from '@/components/base/section'
import Typography from '@/components/base/typography'

import { useHomeHumanMotion } from './motion'
import Spacer from './spacer'
import { cn } from '@/lib/utils'
import { WPMedia } from '@/types'

export type HomeHumanProps = HTMLAttributes<HTMLElement> &
  Partial<{
    paragraph: {
      pretitle: string
      title: string
      text: string
      media: WPMedia
    }
    media: WPMedia
  }>

const HomeHuman = ({ paragraph, media, className, ...props }: HomeHumanProps) => {
  const { pretitle, title, text } = paragraph || {}
  const { motionRef } = useHomeHumanMotion()

  return (
    <Section ref={motionRef} className={cn('overflow-clip', className)} {...props}>
      <div className="grid">
        <div className={cn('col-[1/-1] row-[1/-1]', 'relative')} data-motion-media>
          {(media?.poster?.url || media?.video?.url) && (
            <div className="pointer-events-none absolute left-0 top-0 h-full w-full">
              {/* <div className="absolute inset-0 z-10 bg-[black]/20" /> */}
              <Media media={media} className="" />
            </div>
          )}
        </div>

        <div className="relative col-[1/-1] row-[1/-1]">
          <Spacer variant="2xl" className="bg-transparent dark:bg-transparent" />
          <Spacer variant="2xl" className="bg-transparent dark:bg-transparent" />
          <Spacer variant="2xl" className="bg-transparent dark:bg-transparent" />

          <Container>
            <Grid className="gap-y-spacing-xl md:gap-y-spacing-3xl">
              <div
                className={cn(
                  'col-span-2 md:col-span-4 lg:col-span-6 lg:col-start-2',
                  'grid gap-y-spacing-sm md:gap-y-spacing-lg'
                )}
                data-motion-row
              >
                {pretitle ? (
                  <div className="flex text-text-primary-light mix-blend-overlay">
                    <Typography variant="body" data-motion-pretitle>
                      {pretitle}
                    </Typography>
                  </div>
                ) : null}

                {title ? (
                  <div className="flex text-text-primary-light mix-blend-overlay">
                    <Typography variant="h4" data-motion-title>
                      {title}
                    </Typography>
                  </div>
                ) : null}

                {text ? (
                  <div className="flex">
                    <Typography variant="body" data-motion-paragraph>
                      {text}
                    </Typography>
                  </div>
                ) : null}
              </div>

              <div
                className="col-span-2 md:col-span-4 md:col-start-3 lg:col-span-6 lg:col-start-7"
                data-motion-row
              >
                {paragraph?.media ? (
                  <div className="relative aspect-square overflow-clip rounded-radius-minimal md:aspect-video">
                    <Media
                      media={paragraph.media}
                      className="z-1 pointer-events-none absolute inset-0 h-[115%]"
                      data-motion-paragraph-media
                    />
                  </div>
                ) : null}
              </div>
            </Grid>
          </Container>

          <Spacer variant="2xl" className="bg-transparent dark:bg-transparent" />
          <Spacer variant="2xl" className="bg-transparent dark:bg-transparent" />
          <Spacer variant="2xl" className="bg-transparent dark:bg-transparent" />
        </div>
      </div>
    </Section>
  )
}

export default HomeHuman
